import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from '@heroicons/react/24/outline';

const Hero = () => {
  const scrollToReg = () => document.getElementById('registration').scrollIntoView({ behavior: 'smooth' });

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date('2026-07-13T09:30:00').getTime();
    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setTimeLeft({ days, hours, minutes, seconds });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative overflow-x-hidden w-full min-h-screen flex items-center justify-center bg-gradient-to-br from-[#e6f0fa]/95 to-[#ffffff]/95 px-4 sm:px-6 lg:px-8 py-8 sm:py-16">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="w-full max-w-4xl text-center mt-[-4rem] sm:mt-[-8rem] overflow-hidden"
      >
        <h1
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 sm:mb-8 leading-tight bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent px-6 sm:px-10"
        >
          2026 APCS 模擬測驗團隊 暑期營隊
        </h1>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-[#475569] mb-4 sm:mb-6 font-medium px-6 sm:px-10">
          APCS 模擬測驗團隊
        </p>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-[#475569] mb-8 sm:mb-10 font-light px-6 sm:px-10">
          從邏輯推演到實作創新，培育數位時代的創新人才
        </p>
        <div className="mt-6 sm:mt-10 flex justify-center">
          <div className="flex justify-center gap-6 sm:gap-8 bg-[rgba(96,165,250,0.15)] px-4 sm:px-6 py-3 sm:py-4 rounded-xl border border-[#e0e7ff]/50 shadow-sm">
            {[
              { label: '天', value: timeLeft.days },
              { label: '時', value: timeLeft.hours },
              { label: '分', value: timeLeft.minutes },
              { label: '秒', value: timeLeft.seconds },
            ].map((item, idx) => (
              <div key={idx} className="flex flex-col items-center min-w-[3.5rem]">
                <span className="text-lg sm:text-xl lg:text-2xl font-semibold text-[#60a5fa]">{item.value}</span>
                <p className="text-xs sm:text-sm text-[#475569] mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-center justify-center space-y-6 sm:space-y-0 sm:space-x-6">
          <button
            onClick={scrollToReg}
            className="bg-[rgba(96,165,250,0.9)] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-lg font-semibold hover:bg-[rgba(96,165,250,1)] transition-all duration-300 w-full sm:w-auto"
          >
            立即報名營隊！
          </button>
          <div className="flex items-center space-x-3 sm:space-x-4 px-6 sm:px-10">
            <MapPinIcon className="h-5 sm:h-6 w-5 sm:w-6 text-[#60a5fa]" />
            <span className="text-sm sm:text-base md:text-lg text-[#475569] font-medium">
              陽明交通大學光復校區
            </span>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
